// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4977":"css/admin-app.6746","8708":"css/app.6746"}[chunkId] + ".css";
};